import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';
import { ButtonModel } from '../models/button/button.model';
import { ButtonStylingModel } from '../models/button/button-styling.model';
import { MenuModel } from '../models/menu/menu.model';
import { MenuStylingModel } from '../models/menu/menu-styling.model';

export const /** @type {?} */ MenuTemplates = {
  defaultTemplate: {
    property: new MenuModel({
      display: true,
      disable: false,
      triggerIcon: new IconModel({ name: 'more_vert', size: '30px' }),
      itemsSource: '',
      menuItems: []
    }),
    style: new MenuStylingModel({
      container: { class: '', themeColor: 'primary' },
      iconStyling: {
        container: { class: '' },
        icon: { themeColor: 'primary' }
      },
      menuItemStyling: {
        buttonStyling: {
          container: { class: '' },
          button: { themeColor: 'primary' }
        }
      }
    })
  }
}
